

















import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class PreSales extends Vue {
  @Prop({
    type: Object,
    required: true,
    default: {
      balancePayStartTime: new Date(),
      balancePayEndTime: new Date(),
      deliveryDays: 0,
      expriedTime: 0
    }
  })
  value!: any;
}
